import app from '@/app';

function filter() {
	return value => (value.toExponential ? value.toExponential() : '');
}

app.filter('exp', filter);
